import { createSelector } from '@reduxjs/toolkit';
import {RootState} from "../store.ts";
import {GenerationStatusEnum} from "../../../shared/types/GenerationStatusEnum.ts";

const selectGenerations = (state: RootState) => state.user.generations;

export const selectInProgressGenerations = createSelector(
    [selectGenerations],
    (generations) => generations.filter((g) => g.status === GenerationStatusEnum.PROCESSING && !g.isOptimistic)
);
